import type { ReservedDate } from './reservedDatesClient.types';
import type { ClientContext } from '~/services/contextClient';
import type { QueryParams } from '~/services/api';
import reservedDatesClient from './reservedDatesClient';
import dayjs from '~/utils/dayjs';

const MAX_RANGE_DAYS = 100;

export const fetchReservedDatesInRange = async (
    teamId: number,
    startDate: string,
    endDate: string
): Promise<ReservedDate[]> => {
    const context: ClientContext = { teamId };
    const end = dayjs(endDate);

    const chunks: QueryParams[] = [];
    let chunkStart = dayjs(startDate);

    while (chunkStart.isSameOrBefore(end, 'day')) {
        let chunkEnd = chunkStart.add(MAX_RANGE_DAYS, 'day');
        if (chunkEnd.isAfter(end, 'day')) {
            chunkEnd = end;
        }

        chunks.push({
            start_date: chunkStart.format('YYYY-MM-DD'),
            end_date: chunkEnd.format('YYYY-MM-DD'),
        });

        chunkStart = chunkEnd.add(1, 'day');
    }

    const results = await Promise.all(
        chunks.map(async (chunk) => {
            const response = await reservedDatesClient.getReservedDates(context, chunk);
            return response.data;
        })
    );

    return results.flat();
};
